/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../..';
import { z, ZodTypes } from '../zod';
import { GetClusterContinuousBackup } from './cluster-continuous-backup.get';
import { GetClusterLogicalBackups } from './cluster-logical-backups.get';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterBackupsHistory = {
  id: 'cluster-backups-history.get',
  tag: 'Cluster',
  summary: 'Get cluster backups history',
  description: 'Retrieve a cluster continuous and logical backups history',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/backup/history`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              year: z.number().positive().int(),
              month: z.number().nonnegative().int(),
              backups: z.strictObject({
                continuous: GetClusterContinuousBackup.response[200].content['application/json'].schema,
                logical: GetClusterLogicalBackups.response[200].content['application/json'].schema,
              }),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
